const CDPAIS_COLOMBIA: string = '480';
const CDPAIS_PERU: string = '540';
const TIPODOCUMENTOPROVEEDOR_RUCNIT: string = '01';
const TIPODOCUMENTOPROVEEDOR_GASTODIRECTO: string = '02';
const SCHEMA: string = process.env.REACT_APP_MASTER_MAIN_SCHEMA || '';
const ENTITY: string = process.env.REACT_APP_MASTER_MAIN_ENTITY || '';
const LIST_INGRESO_GASTO: string = `/${process.env.REACT_APP_ROUTE_PATH_MAIN}/${process.env.REACT_APP_ROUTE_PATH_CAJACHICA}/${process.env.REACT_APP_ROUTE_PATH_CAJACHICA_RENDIDOR_INGRESO_GASTOS}`;
const LIST_INGRESO_GASTO_ASOCIADO: string = `/${process.env.REACT_APP_ROUTE_PATH_MAIN}/${process.env.REACT_APP_ROUTE_PATH_CAJACHICA}/${process.env.REACT_APP_ROUTE_PATH_CAJACHICA_RENDIDOR_INGRESO_GASTOS_ASOCIADOS}`;

export const AdapterConfigure = {
    SCHEMA,
    ENTITY,
    CDPAIS_COLOMBIA,
    CDPAIS_PERU,
    TIPODOCUMENTOPROVEEDOR_GASTODIRECTO,
    TIPODOCUMENTOPROVEEDOR_RUCNIT,
    LIST_INGRESO_GASTO,
    LIST_INGRESO_GASTO_ASOCIADO
};